// IMPORTS
// OHS
import { OHSListDataFormatter } from '../../../../../onehivesystems/js/OHSList';
import { OHSFormItem, OHSFormSubmit, OHSFormSubmitListener, OHSFormDataExtractor, OHSFormDataClearer } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';
// Assets
import { locationModel } from './../_variables';


// COMPONENT
export default function Location (props) {
   // Functions
   const updateLocation = function () {
      OHSCRUD({
         url: '/v1/oneport/locations/' + props.content.id.value,
         method: 'PUT',
         payload: OHSFormDataExtractor('oneport-location'),
         success: function (data) {
            var temp = props.parent.locations;
            temp[props.index] = OHSListDataFormatter(data[0], locationModel);
            props.parent.setLocations(temp)
            props.onehive.appWideContent.oneport.buildNavigation(); // refresh the locations + devices in the nav menu
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true
      });
   }
   const deleteLocation = function () {
      OHSCRUD({
         url: '/v1/oneport/locations/' + props.content.id.value,
         method: 'DELETE',
         success: function () {
            props.hidePopup(props.index);
            var temp = props.parent.locations;
            temp.splice(props.index, 1);
            props.parent.setLocations(temp);
            props.onehive.appWideContent.oneport.buildNavigation(); // refresh the locations + devices in the nav menu
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to delete this location?",
         showSuccessPopup: true
      });
   }

   // Component
   return (
      <div id='oneport-location' className='oneport-location' onKeyDown={(e) => {OHSFormSubmitListener(e, updateLocation);}}>
         <OHSFormItem onehive={props.onehive} title="Name">
            <input type='text' className='ohsinput' defaultValue={props.content.name.value} data-ohsformdata='name' />
         </OHSFormItem>
         <OHSFormSubmit onehive={props.onehive} update={updateLocation} clear={() => {OHSFormDataClearer('oneport-location');}} delete={deleteLocation} keyListener={true} />
      </div>
   );
}